<template>
    <img src="../../assets/weixin-not.jpg" alt="" srcset="" v-if="isWeixin"  class="weixin-not" />
    <!-- <div class="mobile mobile-nav" v-if="!isWeixin" >
        <p class="icon-title">
            <i></i>
            <span>妙音成语</span>
            <img src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/title-text.png" alt="" srcset="">
        </p>
        <span @click="openApp">下载APP</span>
    </div> -->
    <!-- <transition name="el-zoom-in-bottom" v-if="!isWeixin">
        <div class="mobile mobile-bootom" v-show="isShownav">
            <p class="icon-title">
                <i></i>
                <span>妙音成语</span>
                <img src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/title-text.png" alt="" srcset="">
            </p>
            <span @click="openApp">下载APP</span>
        </div>
    </transition> -->
    <div class="home" v-if="!isWeixin">
        <!-- <img src="../../assets/home/banner/Slice-1.png" alt="" ref="bannerHeight"/> -->
        <div class="banner" ref="distanceTop">
            <el-carousel
                trigger="click"
                loop
                indicator-position="none"
                arrow="never"
                :height="state.autoHeight"
            >
                <el-carousel-item
                    v-for="(item, index) in state.imgList"
                    :key="item"
                >
                    <img :src="item" alt="" :ref="(el) => (rain[index] = el)" />
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="home-content app-cont">
            <img
                class="img-bj"
                src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/Mask%20group.png"
                alt=""
                srcset=""
            />
            <div class="swiper-box">
                <h5>妙音成语App</h5>
                <p class="title-desc pc">
                    妙音传新时代国学&nbsp;&nbsp;数科铸元宇宙世界
                </p>
                <p class="title-desc mobile">
                    妙音传新时代国学数科铸元宇宙世界
                </p>
                <swiper
                    :effect="'coverflow'"
                    :grabCursor="true"
                    :loop="true"
                    :centeredSlides="true"
                    :slidesPerView="'auto'"
                    :coverflowEffect="{
                        rotate: 15,
                        stretch: 0,
                        depth: 150,
                        modifier: 1,
                        slideShadows: true,
                    }"
                    :pagination="false"
                    :modules="modules"
                    class="mySwiper"
                >
                    <swiper-slide
                        ><img
                            src="../../assets/swiper/21.png" /></swiper-slide
                    ><swiper-slide
                        ><img
                            src="../../assets/swiper/22.png" /></swiper-slide
                    ><swiper-slide
                        ><img
                            src="../../assets/swiper/23.png" /></swiper-slide
                    >
                    <swiper-slide
                        ><img
                            src="../../assets/swiper/24.png" /></swiper-slide
                    >
                    <swiper-slide
                        ><img
                            src="../../assets/swiper/25.png" /></swiper-slide
                    >
                </swiper>
                <p class="curriculum-desc pc">
                    妙音成语，遴选中华经典名句365句，每课以一句经典名句为主题，在精彩的动漫情境小故事中，引导孩子们活学、活用中华传统经典名句。动画过后，设有AI互动答题，方便及时检验学习成果。
                </p>
                <!-- <p class="curriculum-desc mobile">
                    为国学爱好者倾心打造，为弘扬中华优秀传统文化而生<br>
                    内含妙记、知音、动态、漫读四大核心板块<br>
                    囊括国学经典、诗词、书画、围棋、灯谜等优质国学内容 <br>
                    熔阅读、学习、社交、游戏于一炉<br>
                    集文库、动漫、直播、AI互动教学等高新数字技术于一体<br>
                    国学文化+元宇宙+社交圈子，立足本土，走向世界<br>
                </p> -->
                <!-- <div class="curriculum-btn">
                    <p @click="LearnAboutApp">了解更多</p>
                    <p @click="DownloadApp">下载APP</p>
                </div> -->
            </div>
        </div>
        
        <!-- <div class="home-content calligraphy">
            <img
                src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/Mask%20group-2.png"
                alt=""
                srcset=""
                class="img-bj"
            />
            <div class="calligraphy-img">
                <img
                    src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/shici-1.png"
                    alt=""
                    srcset=""
                />
            </div>
        </div> -->
        
        <!-- <div class="home-content cartoon">
            <img
                src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/Mask%20group-4.png"
                alt=""
                srcset=""
                class="img-bj"
            />
            <div class="cartoon-box">
                <div class="cartoon-left">
                    <h5>原创漫画&nbsp;&nbsp;妙音成语</h5>
                    <p>
                        “妙音漫画”，系出自专业手绘师之手。我们积极从中华经典文化内容中取材，以“手绘漫画+传统文化”“奇幻穿越+历史故事”为表现形式，以卡通IP形象泰极熊、妇好等穿越时空与古人对话为主线，精心营造奇幻、浪漫的故事情境，旨在用漫画的形式传播国学文化知识，弘扬中华优秀传统文化，最终实现用传统文化化育人心的目的。<br />
                        “妙音漫画”画风明快，故事紧凑，情节感人，彰显了“妙音数科”人“寓教于乐”传播中华优秀传统文化的文化传播理念。
                    </p>
                </div>
                <div class="cartoon-right">
                    <img
                        src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/manhuaye.png"
                        alt=""
                        srcset=""
                    />
                </div>
            </div>
        </div> -->
        
       
        <!-- <div class="home-content dynamic-content">
            <img
                src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/Mask%20group-3.png"
                alt=""
                srcset=""
                class="img-bj"
            />
            <div class="dynamic-box">
                <h5>妙音开慧&nbsp;&nbsp;数科日新</h5>
                <p>“妙音数科”最新动态</p>
                <div class="dynamic-mobile mobile">
                    “妙音数科”以妙音成语App为数字载体，以传统国学经典、书画、围棋等中华优秀传统文化为基本内容，以直播、动漫、AI互动等为教育方式，最终实现弘扬中华优秀传统文化、传道树人的宏愿。
                </div>
                <div class="dynamic">
                    <div class="dynamic-desc pc">
                        <h6>妙音数科</h6>
                        <p>
                            “妙音数科”以妙音成语App为数字载体，以传统国学经典、书画、围棋等中华优秀传统文化为基本内容，以直播、动漫、AI互动等为教育方式，通过虚拟数字人物的创生，虚拟空间的营造，VR技术的使用，旨在倾心打造富于高新技术含量的集教育、社交、娱乐于一体的逼真“元宇宙”世界，最终实现弘扬中华优秀传统文化、传道树人的宏愿。
                        </p>
                    </div>
                    <div class="dynamic-cont">
                        <div class="dynamic-cont-img">
                            <img
                                src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/shouyedongtai-1.png"
                                alt=""
                                srcset=""
                            />
                        </div>
                        <div class="dynamic-cont-title">
                            <h6>“妙音成语”，新装隆重上线！</h6>
                            <p>
                                今年高考作文，“本手、妙手、俗手”，三个围棋术语引起了大家的热议，不少人直呼没下过围棋，根本看不懂！<br />
                                围棋，中国国粹，世界瑰宝。点线之间有无穷变化，纵横之间有精妙内涵。黑白之间，见证人生成败；方圆之际，阅尽人间万相。
                            </p>
                        </div>
                    </div>
                    <div class="dynamic-cont">
                        <div class="dynamic-cont-img">
                            <img
                                src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/shouyedongtai-2.png"
                                alt=""
                                srcset=""
                            />
                        </div>
                        <div class="dynamic-cont-title">
                            <h6>“妙音数科”拟在香港投资设立全资子公司</h6>
                            <p>
                                为进一步统筹规划公司发展业务，开拓海外市场，促进公司快速发展，增强公司综合竞争力和长远国际化发展规划，公司在香港设立全资子公司——香港妙音数字科技有限公司
                            </p>
                        </div>
                    </div>
                    <div class="dynamic-cont">
                        <div class="dynamic-cont-img">
                            <img
                                src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/shouyedongtai-3.png"
                                alt=""
                                srcset=""
                            />
                        </div>
                        <div class="dynamic-cont-title">
                            <h6>
                                “漫读”模块：期刊、小说VIP会员畅读功能重磅上线！
                            </h6>
                            <p>
                                为丰富“漫读”模块内容，满足广大读者朋友们的阅读需求，我们积极引进期刊、小说版权，供“妙音尊享VIP”畅读。期刊涵盖：文学文摘、家庭亲子、K12教育等十六大方面；经典网络小说，涵盖：古代、现代等类别。内容丰富，精彩纷呈，翘首以待您的到来！
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->


        <!-- <div class="home-content emoticon">
            <h5>妙音表情包</h5>
            <p>动漫铸辉煌&nbsp;&nbsp;数科启新章</p>
            <div class="emoticon-box">
                <ul class="emoticon-item">
                    <li>
                        <div class="emoticon-title">
                            <p>
                                <span>泰极日常第一弹 </span>
                            </p>
                        </div>
                        <div class="emoticon-img">
                            <img
                                src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/biaoqing1.png"
                                alt=""
                                srcset=""
                            />
                        </div>
                        <div class="emoticon-cont left">
                            <p>
                                <span class="pc"
                                    >眼睛虽小但总是睁的圆圆的，充满了生命力。好动，如果保持一个动作时间过长仿佛就会浑身痒痒。</span
                                >
                                <span class="moblie"
                                    >眼睛虽小但总是睁的圆圆的，充满了生命力。</span
                                >
                            </p>
                        </div>
                    </li>
                    <li>
                        <div class="emoticon-cont right">
                            <p>
                                <span class="pc"
                                    >《华严经》记载，我们每个人身都有两个神，一个叫同名，跟我们的名字相同;一个叫同生，我们生他就生，我们灭的时候他也灭。我们起心动念、所有一切造作，他们都知道...</span
                                >
                                <span class="mpblie">同名跟我们的名字相同;同生，我们生他就生，我们灭</span>
                            </p>
                        </div>
                        <div class="emoticon-img">
                            <img
                                src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/biaoqing2.png"
                                alt=""
                                srcset=""
                            />
                        </div>
                        <div class="emoticon-title title-left">
                            <p>
                                <span>同身同名</span>
                            </p>
                        </div>
                    </li>
                    <li>
                        <div class="emoticon-title">
                            <p>
                                <span>泰若水日常第一弹</span>
                            </p>
                        </div>
                        <div class="emoticon-img">
                            <img
                                src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/biaoqing3.png"
                                alt=""
                                srcset=""
                            />
                        </div>
                        <div class="emoticon-cont left">
                            <p>
                                <span class="pc"
                                    >拥有一双水灵灵的大眼睛，有着小巧的脸庞，这就是我们萌萌哒的泰若水啦！</span
                                >
                                <span class="moblie">拥有一双水灵灵的大眼睛，我们萌萌哒的泰若水啦！</span>
                            </p>
                        </div>
                    </li>
                    <li>
                        <div class="emoticon-cont right">
                            <p>
                                <span class="pc"
                                    >红红火火过新春，鞭炮声声响新春。泰极在这里祝大家家和万事兴、年年有余。</span
                                >
                                <span class="moblie">拥有一双水灵灵的大眼睛，我们萌萌哒的泰若水啦！</span>
                            </p>
                        </div>
                        <div class="emoticon-img">
                            <img
                                src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/biaoqing4.png"
                                alt=""
                                srcset=""
                            />
                        </div>
                        <div class="emoticon-title title-left">
                            <p>
                                <span>泰极若水新年表情</span>
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
        </div> -->


        <!-- <div class="home-content study">
            <img
                src="https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/Mask%20group-1.png"
                alt=""
                srcset=""
                class="img-bj"
            />
            <div class="study-box">
                <h5>丰富有趣的学习内容</h5>
                <p>3维教学服务体系&nbsp;&nbsp;&nbsp;&nbsp;实力+服务完美结合</p>
                <div class="learning-content">
                    <div
                        class="learning-content-item"
                        v-for="(item, index) in state.learningList"
                        :key="index"
                    >
                        <div class="images">
                            <img :src="item.img" alt="" srcset="" />
                        </div>
                        <div class="learning-desc">
                            <p>{{ item.desc }}</p>
                            <p>{{ item.name }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        
        <qrCode
            :isQrCode="state.isQrCode"
            @closeDia="closeDia"
            type="DownloadApp"
        />
        <rightAffix></rightAffix>
    </div>
    <div class="footer-moblie moblie" v-if="!isWeixin">
        <p>
            Copyright (C)2002-2022 妙音成语 , <br>
             版权所有 妙音数科 总机: 010-88570166 <br>
            广播电视节目制作经营许可证（京）字06708号 <br>
            网络文化经营许可证京网文（2021）3828-999号 <br>
            增值电信业务经营许可证京B2-20213833 <br>
            <a
                href="https://beian.miit.gov.cn/#/Integrated/index"
                class="blank-a"
                target="_blank"
                rel="noopener noreferrer"
                >京ICP备05016346号-1</a
            >
                <br>
            <!-- Tel：010-88579913 -->
        </p>
    </div>
</template>
<script>
import {
    defineAsyncComponent,
    defineComponent,
    onMounted,
    onUnmounted,
    reactive,
    ref,
    watch,
} from "vue";
import { useRouter } from "vue-router";
// import Slice_1 from "@/assets/home/banner/Slice-1.jpg";
// import Slice_2 from "@/assets/home/banner/Slice-2.png";
// import Slice_3 from "@/assets/home/banner/Slice-3.png";
import qrCode from "@/components/qr_code_com.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import {
    A11y,
    Autoplay,
    EffectCoverflow,
    Pagination,
    Navigation,
    EffectFade
} from "swiper";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-fade";


// import "swiper/css";
// import "swiper/css/autoplay";
// import "swiper/css/effect-coverflow";
// import "swiper/css/pagination";
export default defineComponent({
    setup() {
        const state = reactive({
            // Slice_2, Slice_3
            imgList: [
                "https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/banner-shouye-1.jpg",
                // "https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/banner-shouye-2.png",
            ],
            autoHeight: 0,
            learningList: [
                {
                    img: "https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/learning1.png",
                    desc: "180+",
                    name: "绘画技法",
                },
                {
                    img: "https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/learning2.png",
                    desc: "100+",
                    name: "国画大师",
                },
                {
                    img: "https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/learning3.png",
                    desc: "200+",
                    name: "历朝历代名作",
                },
                {
                    img: "https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/learning4.png",
                    desc: "了解6个",
                    name: "朝代书画史",
                },
                {
                    img: "https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/learning5.png",
                    desc: "笔法",
                    name: "(执笔和用笔)",
                },
                {
                    img: "https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/learning7.png",
                    desc: "字法",
                    name: "(字的结构)",
                },
                {
                    img: "https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/learning6.png",
                    desc: "章法",
                    name: "(结构布局)",
                },
                {
                    img: "https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/learning8.png",
                    desc: "墨法",
                    name: "(墨色的表现方式)",
                },
            ],
            isQrCode: false,
        });
        const Router = useRouter();

        //自动轮播的配置
        const autoplayOptions = {
            autoplay: true,
            delay: 3000,
        };
        const onSwiper = (swiper) => {
            console.log(swiper);
        };
        const onSlideChange = (e) => {
            // swiper切换的时候执行的方法
            console.log("slide change", e.activeIndex);
        };
        const LearnMore = (name) => {
            Router.push({
                name: name,
            });
            sessionStorage.removeItem("routPath");
        };
        //下载APP
        const DownloadApp = () => {
            state.isQrCode = true;
        };
        //关闭弹窗
        const closeDia = () => {
            state.isQrCode = false;
        };
        //了解APP
        const LearnAboutApp = () => {
            Router.push({ name: "LearnAboutApp" });
        };
        const rain = ref([]);
        const clientWidthNum = ref()
        const distanceTop = ref()
        const isShownav = ref(false)
        onMounted(() => {
            // setTimeout(() => {
                
                if(document.documentElement.clientWidth <= 750){
                        state.autoHeight = "1.87rem"
                }else{
                    state.autoHeight = (document.documentElement.clientWidth * 375) / 1200 + "px";
                }
                // console.log(state.autoHeight,document.documentElement.clientWidth);
                // console.log("循环操dom", rain.value);
                window.addEventListener("resize", () => {
                    // state.autoHeight = document.body.clientWidth * 0.412;
                    state.autoHeight = (document.documentElement.clientWidth * 375) / 1200 + "px";
                    if(document.documentElement.clientWidth <= 750){
                        state.autoHeight = "1.87rem"
                    }
                    // console.log("循环操dom", rain.value);
                    // console.log(state.autoHeight,document.documentElement.clientWidth);
                });
                clientWidthNum.value = document.documentElement.clientWidth
                window.onresize = onresize
            // });
            
        });
        const CallApp = require("../../utils/callapp");
        const isWeixin = ref(false)
        const openApp = () => {
            let ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                isWeixin.value = true
                return
            }
            const setting = {
                protocol: "miaoyinguoxue",
                host: "com.example.miaoyingx",
                appstore:
                    "https://itunes.apple.com/cn/app/id1535756243?mt=8",
                fallback: "https://gx.miaoyin.cn/android/apk/miaoyin.apk",
            }
            const options = {
                scheme: {
                    protocol: setting.protocol,
                    // protocol:"zhihu",
                    host: setting.host,
                },
                intent: {
                    // 安卓原生谷歌浏览器必须传递Intent协议地址,才能唤起APP。
                    package: setting.host, // Android包名
                    scheme: setting.protocol, // 和protocol一样:APP协议,URL Scheme的scheme字段,就是你要打开的APP的标识
                },
                appstore: setting.appstore,
                yingyongbao: "", //如果不填写，则安卓微信中会直接跳转 fallback
                fallback: setting.fallback,
                timeout: 5000,
            };
            const callLib = new CallApp(options);
            callLib.open({
                path: "home",
                // param: "", //需要传递的参数
                // / 自定义唤端失败回调函数,传递callback会覆盖callapp-lib库中默认的唤端失败处理逻辑
                // callback: function () {
                //     console.log('唤端失败的处理');
                // }
            });
        };
        const handleScrollx = ()=>{
            let topNum = distanceTop.value.getBoundingClientRect().top
            if(topNum < 0){
                isShownav.value = true

            }else{
                isShownav.value = false
            }
            
        }
        const onresize = ()=>{
            clientWidthNum.value = document.documentElement.clientWidth
        }
        watch(() =>clientWidthNum.value, (pre)=>{
                // console.log(pre);
                // //屏幕小于1180时为移动端适配
                if(pre <= 1180){
                    window.addEventListener('scroll',handleScrollx)
                }
            
        })
        onUnmounted(()=>{
            // console.log('组件删除');
            window.removeEventListener('scroll',handleScrollx)
        })
        return {
            state,
            rain,
            autoplayOptions,
            onSwiper,
            onSlideChange,
            modules: [A11y, Autoplay, EffectCoverflow, Pagination, Navigation,EffectFade],
            LearnMore,
            DownloadApp,
            closeDia,
            LearnAboutApp,
            distanceTop,
            isShownav,
            openApp,
            isWeixin
        };
    },
    components: {
        Swiper,
        SwiperSlide,
        rightAffix: defineAsyncComponent(() =>
            import("@/components/right_affix_com.vue")
        ),
        qrCode,
    },
});
</script>
<style lang="less" scoped>
.weixin-not{
    width: 100%;
}

.home {
    // position: relative;
    background: #fffbef;
    
    /deep/.el-carousel__container {
        // min-height: 500px;
        // max-height: 800px;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
    .swiper {
        width: 100%;
        padding-top: 50px;
        padding-bottom: 50px;
    }

    // .swiper-slide {
    //     background-position: center;
    //     background-size: cover;
    //     width: 300px;
    //     height: 300px;
    // }

    // .swiper-slide img {
    //     display: block;
    //     width: 100%;
    // }
    .swiper {
            width: 900px;
            /deep/.swiper-pagination-bullet {
                background: #fff;
                opacity: 1;
            }
            /deep/.swiper-pagination-bullet-active {
                background: #a72126;
            }
        }
    .home-content {
        width: 1200px;
        margin: auto;

        /deep/.mySwiper {
            .swiper-slide-shadow-left {
                background-image: linear-gradient(
                    to left,
                    rgba(0, 0, 0, 0.2),
                    rgba(0, 0, 0, 0)
                );
            }
            .swiper-slide-shadow-right {
                background-image: linear-gradient(
                    to right,
                    rgba(0, 0, 0, 0.2),
                    rgba(0, 0, 0, 0)
                );
            }
        }
        h5 {
            font-size: 36px;
            text-align: center;
            padding: 50px 0 20px;
        }
        p {
            text-align: center;
            font-size: 24px;
            color: #666666;
        }
        
        /deep/.swiper-slide {
            width: 360px;
            height: 640px;
            // box-shadow: 6px 6px 10px rgba(0, 0, 0, 0.25);
            box-shadow: 6px 6px 10px rgba(0, 0, 0, 0.25);
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        // .swiper-slide{
        //     width: 225px;
        //     height: 400px;
        // }
        .curriculum-desc {
            font-size: 18px;
            color: #000;
            text-align: left;
        }
        .curriculum-btn {
            display: flex;
            justify-content: center;
            padding: 60px 0 120px;
            p {
                width: 200px;
                height: 51px;
                font-size: 18px;
                color: #fff;
                text-align: center;
                line-height: 51px;
                border-radius: 5px;
                cursor: pointer;
            }
            p:first-child {
                background: #151723;
                margin-right: 20px;
            }
            p:last-child {
                background: #a72126;
            }
        }
    }
    .app-cont {
        width: 100%;
        position: relative;
        padding-bottom: 60px;
        .img-bj {
            position: absolute;
            left: 0;
            top: 0;
            height: 100%;
        }
    }
    .dynamic-content {
        width: 100%;
        position: relative;
        > img {
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
        }
        .dynamic-box {
            width: 1200px;
            margin: auto;
        }
    }
    .study{
        width: 100%;
        position: relative;
        >img{
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
        }
        .study-box{
            width: 1200px;
            margin: auto;
        }
    }
    .swiper-box {
        width: 937px;
        margin: auto;
        .title-desc {
            letter-spacing: 18px;
        }
    }
    .comic {
        width: 100%;
        background: url("https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/bj_2.png");
        background-color: #f0c239;
        h5 {
            font-size: 36px;
            text-align: center;
            padding: 50px 0 20px;
        }
        p {
            text-align: center;
            font-size: 24px;
            color: #666666;
        }
        .comic-desc {
            color: #000;
            span:first-child {
                margin-right: 80px;
            }
        }
        .swiper {
            width: 1120px;
            // height: 729px;
            padding: 0 0 88px;
        }
        .comic-box {
            background: #fff;
            margin-top: 30px;
            .comic-item {
                display: flex;
                align-items: center;
                .comic-item-right {
                    width: 380px;
                    height: 243px;
                    background: #666666;
                    img {
                        width: 100%;
                    }
                }
                .comic-item-left {
                    flex: 1;
                    // padding: 0 30px;
                    box-sizing: border-box;
                }
                .text {
                    background: none;
                    padding: 0 30px;
                    box-sizing: border-box;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                }
                h6 {
                    font-size: 24px;
                    color: #000;
                    margin-bottom: 16px;
                }
                p {
                    font-size: 18px;
                    color: #000;
                    text-align: left;
                    line-height: 33px;
                }
            }
        }
    }
    .calligraphy {
        width: 100%;
        position: relative;
        > img {
            // width: 100%;
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
        }
        .calligraphy-img {
            width: 1386px;
            margin: auto;
            img {
                width: 100%;
            }
        }
        .swiper {
            width: 100%;
            height: 780px;
            padding: 0;
            .swiper-slide {
                height: 100%;
                background: #666666;
            }
        }
    }
    .calligraphy-class {
        width: 100%;
        background: url("https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/bj_3.png");
        background-color: #b13b2e;
        padding: 100px 0;
        .calligraphy-class-box {
            display: flex;
            width: 1190px;
            margin: auto;
        }
        .calligraphy-class-desc {
            width: 280px;
            color: #fff;
            h5 {
                font-size: 30px;
                padding: 0 0 20px;
                text-align: left;
            }
            p {
                font-size: 18px;
                text-align: left;
                color: #fff;
                line-height: 25px;
            }
            .calligraphy-title-desc {
                margin-bottom: 50px;
            }
            span {
                display: inline-block;
                padding: 13px 64px;
                background: #fff;
                font-size: 18px;
                color: #000;
                border-radius: 5px;
                cursor: pointer;
            }
            .comic-learn-more {
                margin-top: 50px;
            }
        }
        .calligraphy-class-images {
            flex: 1;
            margin-left: 24px;
            display: flex;
            justify-content: space-between;
            align-content: space-between;
            flex-flow: wrap;
            > div {
                width: 430px;
                height: 280px;
                background: #eee;
                img {
                    width: 100%;
                }
            }
        }
    }
    .cartoon {
        width: 100%;
        position: relative;
        .cartoon-box {
            display: flex;
            position: relative;
            width: 1190px;
            margin: auto;
        }
        > img {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
        }

        .cartoon-left {
            width: 277px;
            color: #000;
            h5 {
                font-size: 30px;
                text-align: left;
            }
            p {
                font-size: 18px;
                color: #000;
                text-align: left;
            }
            span {
                display: inline-block;
                padding: 13px 64px;
                background: #a72126;
                border-radius: 5px;
                color: #fff;
                cursor: pointer;
                margin: 127px 0 56px;
                font-size: 18px;
            }
        }
        .cartoon-right {
            // width: 100%;
            flex: 1;
            margin-left: -30px;
            font-size: 0;
            img {
                width: 100%;
            }
        }
    }
    .comic-calligraphy {
        background: url("https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/bj_3.png");
        background-color: #3d8e86;
    }
    .dynamic {
        display: flex;
        justify-content: space-between;
        padding: 60px 0 90px;
        > div {
            width: 280px;
        }
        > div:not(:first-child) {
            background: #ffffff;
        }
        .dynamic-desc {
            color: #000;
            h6 {
                font-size: 24px;
            }
            p {
                font-size: 19px;
                color: #000;
                text-align: left;
                line-height: 28px;
                margin: 20px 0 53px;
            }
            span {
                display: inline-block;
                padding: 13px 64px;
                background: #a72126;
                border-radius: 5px;
                color: #fff;
                cursor: pointer;
                font-size: 18px;
            }
        }
        .dynamic-cont {
            .dynamic-cont-img {
                width: 100%;
                height: 222px;
                overflow: hidden;
                background: #eee;
                img {
                    width: 100%;
                }
            }
            .dynamic-cont-title {
                padding: 23px 16px;
                h6 {
                    font-size: 18px;
                    color: #000;
                    font-weight: 400;
                }
                p {
                    text-align: left;
                    font-size: 14.5px;
                    color: #000;
                    line-height: 22px;
                    margin-top: 15px;
                }
            }
        }
    }
    .emoticon {
        width: 100%;
        background: url("https://miaoyinguoxue.oss-cn-beijing.aliyuncs.com/Web/bj_3.png");
        background-color: #151729;
        h5 {
            color: #fff;
        }
        p {
            color: #fff;
        }
        .emoticon-box {
            width: 1180px;
            margin: auto;
            .emoticon-item {
                padding: 60px 0 58px;
                li {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 20px;
                    div:not(:nth-child(2)) {
                        // flex: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                    }
                    div:nth-child(2) {
                        width: 130px;
                        height: 130px;
                        background: #fff;
                        border-radius: 50%;
                        overflow: hidden;
                    }
                    .emoticon-title {
                        flex: 1;
                        align-items: flex-end;

                        p {
                            // width: 200px;
                            padding-right: 80px;
                            text-align: left;
                            color: #fff;
                            font-size: 24px;
                            span {
                                display: block;
                            }
                            span:last-child {
                                font-size: 18px;
                            }
                        }
                    }
                    .title-left {
                        align-items: flex-start;

                        p {
                            width: auto;
                            text-align: left;
                            padding-left: 80px;
                            box-sizing: border-box;
                        }
                    }
                    .emoticon-cont {
                        flex: 1;
                        align-items: flex-end;
                        p {
                            width: 400px;
                            padding: 27px 15px;
                            background: #fff;
                            font-size: 14px;
                            color: #000;
                            text-align: left;
                            position: relative;
                        }
                    }
                    .right {
                        flex: 1;
                        align-items: flex-start;
                        p:before {
                            content: "";
                            width: 0px;
                            height: 0px;
                            border-top: 10px solid transparent;
                            border-bottom: 10px solid transparent;
                            border-left: 15px solid #fff;
                            position: absolute;
                            top: 50%;
                            right: -15px;
                            margin-top: -10px;
                        }
                    }
                    .left {
                        p:before {
                            content: "";
                            width: 0px;
                            height: 0px;
                            border-top: 10px solid transparent;
                            border-bottom: 10px solid transparent;
                            border-right: 15px solid #fff;
                            position: absolute;
                            top: 50%;
                            left: -15px;
                            margin-top: -10px;
                        }
                    }
                }
            }
        }
    }
    .learning-content {
        width: 900px;
        margin:60px auto 0;
        display: flex;
        justify-content: space-between;
        
        flex-flow: wrap;
        // padding: 60px 0 186px;
        
        .learning-content-item {
            // width: 130px;
            width: 210px;
            height: 218px;
            // padding: 0 40px;
            margin-bottom: 28px;
            .images {
                width: 130px;
                height: 130px;
                background: #fff;
                overflow: hidden;
                border-radius: 50%;
                margin: auto;
            }

            .learning-desc {
                margin-top: 36px;
                p {
                    font-size: 20px;
                    color: #000;
                }
            }
        }
    }
}
@import "./mediaClass/index.less";
</style>